import { AdminClassroomLayout } from "@/pages/admin/AdminClassroomLayout";
import { StudentReportPage } from "@/pages/teacher/StudentReportPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/classrooms/$classroomId/students/$studentId/report/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { classroomId, studentId } = Route.useParams();
  return (
    <AdminClassroomLayout>
      <StudentReportPage classroomId={classroomId} studentId={studentId} scope="admin" />
    </AdminClassroomLayout>
  );
}
